import { Builder } from '@builder.io/react';

import VideoModal from './index';

Builder.registerComponent(VideoModal, {
  name: 'VideoModal',
  inputs: [
    {
      name: 'url',
      type: 'url'
    },
    {
      name: 'poster',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
    },
    {
      name: 'smallButton',
      type: 'boolean'
    },
    {
      name: 'controls',
      type: 'boolean'
    },
    {
      name: 'blackButton',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'hideCloseButton',
      type: 'boolean',
      defaultValue: false
    }
  ]
});
